module.exports = __webpack_public_path__ + "img/PL09297.935b5b76.png";